/**
 * jQuery Spotlight
 *
 * Project Page: http://dev7studios.com/portfolio/jquery-spotlight/
 * Copyright (c) 2009 Gilbert Pellegrom, http://www.gilbertpellegrom.co.uk
 * Licensed under the GPL license (http://www.gnu.org/licenses/gpl-3.0.html)
 * Version 1.0 (12/06/2009)
 */

(function($) {

    $.fn.spotlight = function(options) {
        // Default settings
        var settings = $.extend({}, {
            opacity: .5,
            speed: 400,
            color: '#333',
            easing: 'ease-out',
            exitEvent: 'click',
            onShow: function(){},
            onHide: function(){}
        }, options);

        if ($('#spotlight').size() == 0) {
            // Add the overlay div
            var spotlight = $('<div id="spotlight"></div>');

            // Set the CSS styles
            spotlight.css({
                              'position':'fixed',
                              'background':settings.color,
                              'opacity': 0,
                              'filter': 'alpha(opacity=0)',
                              'top': 0,
                              'left': 0,
                              'right': 0,
                              'bottom': 0,
                              'z-index':'9998'
                          });

            spotlight.css('transition', 'opacity ' + settings.speed + 'ms ' + settings.easing);
            spotlight.appendTo($('body'));
            spotlight.css('opacity');
            spotlight.css('opacity', settings.opacity);
            spotlight.css('filter', 'alpha(opacity=' + settings.opacity * 100 + ')');

            // Get our elements
            var element = $(this);

            // Set element CSS
            var currentPos = element.css('position');
            if(currentPos == 'static'){
                element.css('position', 'relative');
            }
            element.css('z-index', '9999');

            // Set up click to close
            spotlight.on(settings.exitEvent, function(){
                spotlight.css('opacity', 0);
                spotlight.css('filter', 'alpha(opacity=0)');
                setTimeout(function() {
                    if(currentPos == 'static') element.css('position', 'static');
                    element.css('z-index', '1');
                    spotlight.remove();
                    // Trigger the onHide callback
                    settings.onHide.call(this);
                }, settings.speed);
            });

            // added by hzhang, to enable manually closing the spotlight effect
            this.hideSpotlight = function() {
                spotlight.trigger(settings.exitEvent);
            };
        }

        // Returns the jQuery object to allow for chainability.
        return this;
    };

})(jQuery);